module.exports = __webpack_public_path__ + "assets/img/s1.45f29f41.png";